import React, { useState } from "react";
import { connect } from "react-redux";
import { NavLink, useHistory, useLocation } from "react-router-dom";
import Icon from 'react-icons-kit';
import {standby} from 'react-icons-kit/iconic/standby';
import Sidebar from "./Sidebar";
import { useTranslation } from "react-i18next";
import { userLogout } from "../redux/auth/action";
import { showModal } from "../redux/modal/actions";



export const LayoutContext = React.createContext();

const UserLayout = ({ children, showModal, userLogout }) => {
  const { i18n } = useTranslation();
  const [pageTitle, setPageTitle] = useState("");
  const [mobileOpen, setMobileOpen] = useState(false);
  const history = useHistory();

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    localStorage.setItem("currentLanguage", lng);
    setMobileOpen(false);
  };

  const handleLogout = () => {
      showModal({
         title: "Confirm Logout",
        message: "Are you sure you want to logout?",
        yesLabel: "Logout",
        noLabel: "Stay",
        yesType: "api",
        onYes: () => userLogout(history, "/"),
        onNo: () => console.log("Stayed"),
      })
    
  };
  

  return (
    <LayoutContext.Provider value={{ setPageTitle }}>
      <div className="dashboard-wrapper form-modern">
        <main className="content-area p-3">
          <Sidebar />

          <header className="app-header">
            <h3 className="page-title">{pageTitle}</h3>

            {/* Desktop actions */}
            <div className="header-actions desktop-only">
              <select
                value={i18n.language}
                onChange={(e) => changeLanguage(e.target.value)}
              >
                <option value="en">EN</option>
                <option value="de">DE</option>
              </select>

              <button
              className="logout-icon"
             onClick={handleLogout}
              title="Logout"
            >
              <Icon icon={standby} />
            </button>

            </div>

          </header>

    
          {children}
        </main>
      </div>
    </LayoutContext.Provider>
  );
};

export default connect(null, { showModal, userLogout })(UserLayout);